// removed by extract-text-webpack-plugin
module.exports = {"DailySchedule":"DailySchedule","WeeklySchedule":"WeeklySchedule","schoolLogo":"schoolLogo"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/ScheduleDisplayer/print.scss
// module id = Mztg
// module chunks = 0